<template>
  <div class="Sales">
    <v-container>
      <v-layout>
         <v-layout mt-5>
            <v-flex>
                <v-data-table :headers="headers" :items="SubscriptionData" class="elevation-1">
                    <template slot="items" slot-scope="props">
                        <!-- <td>11</td> -->
                        <td class="text-xs-right">{{ props.item.startDate }}</td>
                        <td class="text-xs-right">{{ props.item.endDate }}</td>
                        <td class="text-xs-right">{{ props.item.amount }}</td>
                        <td class="text-xs-right">{{ props.item.package }}</td>
                        <td class="text-xs-right">{{ props.item.dkk }}</td>
                        <td class="text-xs-right"><v-icon>visibility</v-icon></td>
                    </template>
                </v-data-table>
            </v-flex>

        </v-layout>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  name:"Sales",
  data:()=>({
     headers: [
        // {
        //   text: "#",
        //   value: "Number"
        // },
        {
          text: "Start Date",
          value: "startDate"
        },
        { text: "End Date", value: "endDate" },
         { text: "Package", value: "package" },
        { text: "Amount", value: "amount" },
        { text: "DKK", value: "dkk" },
        // { text: "EMAIL", value: "email" },
        // { text: "GENDER", value: "gender" },
        // { text: "STATUS", value: "status" },
        // { text: "CHANGE TEACHER", value: "changeTeacher" }
      ],
      SubscriptionData:[
        {
          startDate:'22.2.2018',
          endDate:'22.2.2018',
          package:"@5",
          amount:'555',
          dkk:'dkk',

        }
      ]
  })
}
</script>


// WEBPACK FOOTER //
// src/pages/pages/profile/Sales.vue